function getLanguage() {
  // Get the language in format of "en-US" then turn it into "en"
  let lang = Intl.DateTimeFormat().resolvedOptions().locale.split('-')[0];

  if (!['en', 'fr', 'el', 'nl', 'ja', 'it'].includes(lang)) lang = 'en';

  return lang;
}

export default getLanguage;
